await import('D:/newMainProject/ilab-web/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('D:/newMainProject/ilab-web/src/.umi/umi.ts');
export default 1;